import styled from 'styled-components';

import { ProgressRing } from '@getgrover/ui';

export const ProgressRingIcon = styled(ProgressRing)`
    position: absolute;
    top: 0;
    left: 0;
`;
